export default __webpack_public_path__ + "static/media/Group 5211.babb70a5.svg";